import {
  DISPLAY_TYPES,
  ESCHEMA_TYPES,
  FORM_TEMP_CONSTANTS
} from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { EditRule } from "@/modules/FormTemplate/models/EditRule";
import { Field } from "@/modules/FormTemplate/models/Field";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { RuleValue } from "@/modules/FormTemplate/models/RuleValue";
import {
  GENERAL_OPERATORS,
  STRING_OPERATORS
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import {
  FORM_CONSTANTS,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { PreventKey } from "@/shared/mixins/mixins";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "AddRule",
  components: {
    DynamicSelect
  }
})
export default class AddRule extends PreventKey {
  @Prop() private dialog!: boolean;
  @Prop() private fields!: Field[];
  @Prop() private dataProp?: {
    rule: FormRule;
    index: number;
  };

  key = 0;
  formRuleName = "";
  formRuleText = "";
  listValue = false;
  isCheckbox = false;
  isNumericValue = false;
  isStringValue = false;
  isDateValue = false;
  isBooleanValue = false;
  showDatePicker = false;
  dateMenu = false;
  formatedDate = "";
  ruleValues: RuleValue[] = [];
  booleanValues: boolean[] = [true, false];
  formRuleField: Field | undefined = {
    indicator: true,
    conversationTitle: "",
    editable: true,
    key: "",
    list: "",
    order: 0,
    required: true,
    schema: {
      title: "",
      type: ""
    },
    summary: true,
    summaryText: "",
    type: "",
    visible: true,
    visualElement: "",
    width: 12
  };
  formRuleOperator = "";
  formRuleValue: RuleValue = {
    title: "",
    value: ""
  };
  ruleForm = false;

  index = -1;

  SAVE = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL = FORM_CONSTANTS.BUTTON.CANCEL;
  RULE_TITLE_DATA = FORM_TEMP_CONSTANTS.RULE_LABEL.ADD_TITLE;
  RULE_TITLE = FORM_TEMP_CONSTANTS.RULE_LABEL.TITLE;
  RULE_TEXT_DESCRIPTION = FORM_TEMP_CONSTANTS.RULE_LABEL.TEXT_DESCRIPTION;
  RULE_FIELD = FORM_TEMP_CONSTANTS.LABEL.FIELD;
  RULE_OPERATOR = FORM_TEMP_CONSTANTS.LABEL.OPERATOR;
  RULE_VALUE = FORM_TEMP_CONSTANTS.LABEL.VALUE;

  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  textAreaClass = STYLE_CLASSES.TEXT_AREA;
  cardClass = STYLE_CLASSES.CARD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  requiredArray = [FORM_VALIDATORS.REQUIRED_ARRAY];
  operators = GENERAL_OPERATORS;
  isEditing = false;
  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.RULE_FIELD,
    required: true
  };
  dynamicFormRuleConfig: DynamicSelectConfig = {
    default: [],
    listAll: [],
    messageLabel: this.RULE_FIELD,
    required: true
  };
  dynamicOperatorConfig: DynamicSelectConfig = {
    default: [],
    listAll: [],
    messageLabel: this.RULE_OPERATOR,
    required: true
  };
  dynamicMultiConfig: DynamicSelectConfig = {
    multiple: true,
    chips: true,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.RULE_VALUE,
    persistenthint: true,
    required: true
  };

  dynamicBooleanConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.booleanValues.map((item: any) => {
      return {
        id: `${item}` ?? "",
        name: `${item}` ?? ""
      };
    }),
    filled: false,
    messageLabel: this.RULE_VALUE,
    persistenthint: true,
    required: true
  };
  listSearch: any = [];
  customSelectModel = [{ id: "", name: "" }];
  formRuleFieldModel = [{ id: "", name: "" }];
  formRuleOperatorModel = [{ id: "", name: "" }];
  formRuleMultiModel = [{ id: "", name: "" }];
  listSearchMulti: any = [];
  boleanSelectModel = [{ id: "", name: "" }];
  regexPattern = new RegExp("true");

  set selectBooleanCustom(value: boolean) {
    const option = this.dynamicBooleanConfig.listAll.find(
      field => this.regexPattern.test(field.id) === value
    );
    this.customSelectModel = [
      {
        id: `${option}` ?? "",
        name: `${option}` ?? ""
      }
    ];
  }
  get selectBooleanCustom() {
    return this.regexPattern.test(this.customSelectModel[0].id);
  }

  get selectMultipleField() {
    return this.formRuleMultiModel.map((item: any) => item.id);
  }

  set selectMultipleField(value: string[]) {
    const option = this.dynamicMultiConfig.listAll.find(
      (item: any) => item.id === value
    );
    this.formRuleMultiModel = [
      {
        id: option?.id ? `${option?.id}` : "",
        name: option?.name ?? ""
      }
    ];
  }

  set selectFormCustom(value: string) {
    const option = this.dynamicSelectConfig.listAll.find(
      field => field.id === value
    );
    this.customSelectModel = [
      {
        id: option?.id ? `${option?.id}` : "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectFormCustom() {
    return this.customSelectModel[0].id;
  }

  set selectFormRuleFieldModel(value: string) {
    const option = this.dynamicFormRuleConfig.listAll.find(
      field => field.id === value
    );
    this.formRuleFieldModel = [
      {
        id: option?.id ? `${option?.id}` : "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectFormRuleFieldModel() {
    return this.formRuleFieldModel[0].id;
  }

  set selectOperator(value: string) {
    const option = this.dynamicOperatorConfig.listAll.find(
      field => field.id === value
    );
    this.formRuleOperatorModel = [
      {
        id: option?.id ? `${option?.id}` : "",
        name: option?.name ?? ""
      }
    ];
  }
  get selectOperator() {
    return this.formRuleOperatorModel[0]?.id;
  }

  formatObjectSelect(ruleValues: any[]) {
    return ruleValues.map(item => {
      return {
        name: item.conversationTitle,
        id: item?.key ? `${item?.key}` : ""
      };
    });
  }

  formatRulesValues(ruleValues: any[]) {
    return ruleValues.map(item => {
      return {
        name: item.title,
        id: item?.id ? `${item?.id}` : ""
      };
    });
  }

  formatOperator(operator: any[]) {
    const operators = operator.map((item: any) => {
      return { id: item.key, name: item.operator };
    });
    return operators;
  }

  searchObjectField(value: string) {
    const searchObject = this.listSearch.find(
      (item: any) => item.key === value
    );

    return searchObject;
  }

  fillRule(): FormRule | boolean {
    let sumaryRule: FormRule;
    if (this.formRuleName !== "" && this.formRuleText !== "") {
      if (this.formRuleField != undefined) {
        sumaryRule = {
          name: this.formRuleName.trim(),
          text: this.formRuleText.trim(),
          field: this.formRuleField.key,
          operator: this.formRuleOperator,
          ruleValue: this.formRuleValue
        };
      } else {
        sumaryRule = {
          name: this.formRuleName.trim(),
          text: this.formRuleText.trim(),
          field: "",
          operator: this.formRuleOperator,
          ruleValue: this.formRuleValue
        };
      }

      return sumaryRule;
    } else {
      return false;
    }
  }

  addRule() {
    this.isEditing = false;
    const index = this.index;
    const sumaryRule = this.fillRule();
    this.clearField();
    if (index === -1) {
      if (typeof sumaryRule !== "boolean") {
        const data: EditRule = { formRule: sumaryRule };
        this.$emit(FORM_TEMP_CONSTANTS.EVENTS.RULE.ADD_NEW, data);
      }
    } else {
      if (typeof sumaryRule !== "boolean") {
        const data: EditRule = { formRule: sumaryRule, index: index };
        this.$emit(FORM_TEMP_CONSTANTS.EVENTS.RULE.ADD_EDITED, data);
      }
    }
  }

  clearField() {
    this.key = 1 - this.key;
    this.formatedDate = "";
    this.formRuleName = "";
    this.formRuleText = "";
    this.formRuleField = {
      indicator: true,
      conversationTitle: "",
      editable: true,
      key: "",
      list: "",
      order: 0,
      required: true,
      schema: {
        title: "",
        type: ""
      },
      summary: true,
      summaryText: "",
      type: "",
      visible: true,
      visualElement: "",
      width: 12
    };
    this.formRuleOperator = "";
    this.formRuleValue = {
      title: "",
      value: ""
    };
    this.index = -1;
    this.listValue = false;
    this.isNumericValue = false;
    this.isStringValue = false;
    this.isDateValue = false;
    this.isBooleanValue = false;
    this.RULE_TITLE_DATA = FORM_TEMP_CONSTANTS.RULE_LABEL.ADD_TITLE;
  }

  clearedField() {
    this.formRuleOperator = "";
    this.formRuleValue.value = "";
    this.formatedDate = "";
  }

  @Watch("dataProp")
  async organizeFormToShow() {
    if (this.dataProp && this.dataProp.index >= 0) {
      this.editGivenRule(this.dataProp.rule, this.dataProp.index);
    } else {
      this.clearField();
    }
  }

  editGivenRule(rule: FormRule, index: number) {
    this.isEditing = true;
    this.clearField();
    this.index = index;
    this.formRuleName = rule.name;
    this.formRuleText = rule.text;
    this.formRuleOperator = rule.operator;

    this.formRuleValue = rule.ruleValue;
    if (typeof rule.ruleValue.value === "boolean") {
      this.formRuleValue.value = this.selectBooleanCustom;
      this.boleanSelectModel = [
        {
          id: `${rule.ruleValue.value}`,
          name: `${rule.ruleValue.value}`
        }
      ];
    }
    if (
      typeof rule.ruleValue.value != ESCHEMA_TYPES.STRING &&
      typeof rule.ruleValue.value != ESCHEMA_TYPES.BOOLEAN &&
      typeof rule.ruleValue.value != ESCHEMA_TYPES.NUMBER &&
      rule.ruleValue.value != undefined &&
      Array.isArray(rule.ruleValue.value)
    ) {
      this.formRuleMultiModel = rule.ruleValue.value.map((item: any) => {
        return {
          id: item,
          name: item
        };
      });
    }

    const optionOperator = this.formatOperator(this.operators).find(
      item => item.id === rule.operator
    );
    this.formRuleOperatorModel = optionOperator ? [optionOperator] : [];
    this.formRuleValue = rule.ruleValue;
    this.formRuleField = this.fields.find(field => field.key === rule.field);
    this.listSearch = this.formatObjectSelect(this.fields);
    this.dynamicFormRuleConfig.listAll = this.listSearch;
    this.selectFormRuleFieldModel = rule.field;

    if (this.formRuleField) {
      this.setOperators(this.formRuleField);
    }
    if (this.isDateValue) {
      const date = this.formatDate(rule.ruleValue.value as string);
      this.formatedDate = date ?? "";
    }
    this.RULE_TITLE_DATA = FORM_TEMP_CONSTANTS.RULE_LABEL.EDIT_TITLE;
  }

  cancel() {
    this.key = 1 - this.key;
    this.isEditing = false;
    this.formRuleName = "";
    this.formRuleText = "";
    this.formRuleField = undefined;
    this.formRuleOperator = "";
    this.formRuleValue = {
      title: "",
      value: ""
    };
    (this.$refs.form as Vue & {
      resetValidation: () => void;
    }).resetValidation();
    this.index = -1;
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CLOSE_DIALOG);
  }

  clearOperator() {
    this.formRuleField = undefined;
    this.formRuleValue = {
      title: "",
      value: ""
    };
    this.isDateValue = false;
    this.isStringValue = false;
    this.isBooleanValue = false;
    this.isNumericValue = false;
    this.formRuleOperator = "";
    this.formatedDate = "";
  }

  @Watch("boleanSelectModel")
  onBoleanSelectModelChange() {
    if (!this.isEditing) {
      this.formRuleValue.value = this.selectBooleanCustom;
    }
  }

  @Watch("formRuleOperatorModel")
  onFormRuleOperatorModelChange() {
    this.formRuleOperator = this.selectOperator;
  }

  @Watch("customSelectModel")
  onCustomSelectModelChange() {
    if (!this.isEditing) {
      this.formRuleValue.value = this.selectFormCustom;
    }
  }

  @Watch("formRuleMultiModel")
  onFormRuleMultiModelChange() {
    if (!this.isEditing) {
      this.formRuleValue.value = this.selectMultipleField;
    }
  }

  @Watch("formRuleOperator")
  onFormRuleOperatorChange() {
    if (!this.isEditing) {
      this.formRuleOperator = this.selectOperator;
    }
  }

  @Watch("formRuleFieldModel")
  onFormRuleFieldModelChange() {
    if (!this.isEditing) {
      const search = this.searchObjectField(this.selectFormRuleFieldModel);
      this.formRuleField = search;
      if (this.formRuleField) {
        this.setOperators(this.formRuleField);
      }
    }
  }

  @Watch("formRuleField")
  fieldChanged() {
    this.ruleValues = [];
    if (!this.isEditing) {
      this.formRuleValue = {
        title: "",
        value: ""
      };
    }

    if (this.formRuleField != undefined && this.formRuleField.list != "") {
      if (
        this.formRuleField.schema["x-display"] != DISPLAY_TYPES.CHECKBOX &&
        this.formRuleField.schema.oneOf != undefined
      ) {
        this.formRuleField.schema.oneOf.forEach(object => {
          const ruleValue: RuleValue = {
            title: object.title,
            value: object.const
          };
          this.ruleValues.push(ruleValue);
          this.dynamicSelectConfig.listAll = this.formatRulesValues(
            this.ruleValues
          );
          const optionCustom = this.dynamicSelectConfig.listAll.find(
            field => field.id === this.formRuleValue.value
          );
          this.customSelectModel = optionCustom ? [optionCustom] : [];
        });
      } else {
        if (
          this.formRuleField.schema.items != undefined &&
          this.formRuleField.schema.items.oneOf != undefined
        ) {
          this.formRuleField.schema.items.oneOf.forEach(object => {
            const ruleValue: RuleValue = {
              title: object.title,
              value: object.const
            };
            this.ruleValues.push(ruleValue);
          });
          this.listSearchMulti = this.formatRulesValues(this.ruleValues);
          this.dynamicMultiConfig.listAll = this.formatRulesValues(
            this.ruleValues
          );
        }
      }
    } else {
      if (
        this.formRuleField != undefined &&
        this.formRuleField.schema.items != undefined
      ) {
        if (
          this.formRuleField.schema["x-display"] == DISPLAY_TYPES.CHECKBOX &&
          this.formRuleField.schema.items.enum != undefined
        ) {
          this.formRuleField.schema.items.enum.forEach(object => {
            const ruleValue: RuleValue = {
              title: object,
              value: object
            };
            this.ruleValues.push(ruleValue);
          });
        }
      } else if (
        this.formRuleField != undefined &&
        this.formRuleField.schema.enum != undefined &&
        this.formRuleField.schema["x-display"] == DISPLAY_TYPES.RADIO
      ) {
        this.formRuleField.schema.enum.forEach(object => {
          const ruleValue: RuleValue = {
            title: object,
            value: object
          };
          this.ruleValues.push(ruleValue);
        });
      }
    }
    this.isEditing = false;
    if (this.formRuleField != undefined) {
      this.dynamicFormRuleConfig.listAll = this.formatObjectSelect(this.fields);
      this.listSearch = this.fields;
      this.setOperators(this.formRuleField);
    }
  }

  setOperators(field: Field) {
    if (field.schema.type === ESCHEMA_TYPES.STRING) {
      if (
        field.schema["x-display"] == DISPLAY_TYPES.RADIO ||
        field.schema["x-display"] == DISPLAY_TYPES.AUTOCOMPLETE
      ) {
        this.listValue = true;
        this.isDateValue = false;
        this.isStringValue = false;
        this.isBooleanValue = false;
        this.isNumericValue = false;
        this.isCheckbox = false;
        this.operators = STRING_OPERATORS;
        this.dynamicOperatorConfig.listAll = this.formatOperator(
          this.operators
        );
      } else if (
        field.schema["x-display"] == DISPLAY_TYPES.STRING &&
        field.schema.format === DISPLAY_TYPES.DATE
      ) {
        this.listValue = false;
        this.isDateValue = true;
        this.isStringValue = false;
        this.isBooleanValue = false;
        this.isNumericValue = false;
        this.isCheckbox = false;
        this.operators = GENERAL_OPERATORS;
        this.dynamicOperatorConfig.listAll = this.formatOperator(
          this.operators
        );
      } else {
        this.listValue = false;
        this.isDateValue = false;
        this.isStringValue = true;
        this.isBooleanValue = false;
        this.isNumericValue = false;
        this.isCheckbox = false;
        this.operators = STRING_OPERATORS;
        this.dynamicOperatorConfig.listAll = this.formatOperator(
          this.operators
        );
      }
    } else if (field.schema.type === ESCHEMA_TYPES.NUMBER) {
      this.listValue = false;
      this.isDateValue = false;
      this.isStringValue = false;
      this.isBooleanValue = false;
      this.isNumericValue = true;
      this.isCheckbox = false;
      this.operators = GENERAL_OPERATORS;
      this.dynamicOperatorConfig.listAll = this.formatOperator(this.operators);
    } else if (field.schema.type === ESCHEMA_TYPES.ARRAY) {
      this.listValue = true;
      if (field.schema["x-display"] == DISPLAY_TYPES.CHECKBOX) {
        this.operators = STRING_OPERATORS;
        this.dynamicOperatorConfig.listAll = this.formatOperator(
          this.operators
        );

        this.isCheckbox = true;
      }
    } else if (field.schema.type === ESCHEMA_TYPES.BOOLEAN) {
      this.listValue = false;
      this.isDateValue = false;
      this.isStringValue = false;
      this.isBooleanValue = true;
      this.isNumericValue = false;
      this.isCheckbox = false;
      this.operators = STRING_OPERATORS;

      this.dynamicOperatorConfig.listAll = this.formatOperator(this.operators);
    } else {
      this.listValue = false;
      this.isCheckbox = false;
      this.isStringValue = true;
      this.isBooleanValue = false;
      this.operators = STRING_OPERATORS;
      this.dynamicOperatorConfig.listAll = this.formatOperator(this.operators);
    }
  }

  formatDate(date: string) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }
}
